var _ = require('underscore');

/**
 * Strips all but 0-9 from a string
 *
 * @param {string} phone
 * @returns {string}
 *
 * @example
 * // returns "1231231234"
 * stripNonDigits("123-123-1234")
 */
var stripNonDigits = function(phone) {
    if (phone) {
        phone = phone.replace(/[^\d]/g, "");
    }
    return phone;
};

/**
 * Checks if URL is relative and makes it absolute if true
 *
 * @param {string} link
 * @returns {string}
 */
var makeAbsolute = function(link) {
    var absoluteUrlRegex = /(?:^[a-z][a-z0-9+.-]*:|\/\/)/i;
    if (link && link.length > 0 && !absoluteUrlRegex.test(link)) {
        return "//" + link;
    }
    return link;
};

/**
 * Parse a URL into its components. Return an object containing properties "protocol", "hostname",
 * "port", "pathname", "search", "hash". Also attaches helper method getUrl, which pieces
 * the URL back together.
 *
 * @param {string} url
 * @returns {object}
 */
var parseUrl = function(url) {
    // Anchor tag parser can sometimes mess with the protocol/port. Keep
    // track of original properties so we can correct if necessary.
    var absoluteUrlRegex = /(?:^[a-z][a-z0-9+.-]*:|\/\/)/i;
    var isAbsolute = absoluteUrlRegex.test(url);
    var hasPort = /:\d+/.test(url);

    // Anchor elements implicity parse a url/href when set.
    // https://gist.github.com/jlong/2428561
    var a = document.createElement("a");
    // Don't want url to be treated as relative (path)
    var absoluteUrl = makeAbsolute(url);
    a.href = absoluteUrl;

    var parts = ["protocol", "hostname", "port", "pathname", "search", "hash"];
    var parsed = _.pick(a, parts);

    if(!isAbsolute) {
        var splitHref = absoluteUrl.split(/^\/\/\//);
        // Checks that url is truly a path (i.e. it follows the "/example" format instead of "www.example.com" format)
        if(splitHref[1]) {
            parsed.hostname = splitHref[0];
            parsed.pathname = splitHref[1];
        }
    }

    // Make sure the pathname always beings with a /
    if (parsed.pathname &&
        parsed.pathname.length > 0 &&
        parsed.pathname[0] !== "/") {
        parsed.pathname = "/" + parsed.pathname;
    }

    parsed.getUrl = function() {
        var protocol = isAbsolute ? this.protocol + "//" : "";
        var port = hasPort ? ":" + this.port : "";
        return protocol + this.hostname + port + this.pathname + this.search + this.hash;
    };
    parsed.toString = parsed.getUrl;
    return parsed;
};

/**
 * We often want the name of the current page, which is the same as the deepest part of the path,
 * in most versioned themes.
 *
 * @param {string} location URL
 * @returns {string}
 *
 */
var getPageName = function(location) {
    var parsedUrl = this.parseUrl(location);
    var pathParts = _.reject(parsedUrl.pathname.split('/'), function(part) { return part === ""; });
    var fileName = pathParts.pop();

    if(!fileName) {
        fileName = "index";
    }
    return fileName;
};

/**
 * Checks for property in obj and adds a stripped version to obj
 *
 * @param {object} obj
 * @param {string} property
 */
var addFormattedPhone = function(object, property) {
    if (object[property]) {
        object[property + "_link_formatted"] = stripNonDigits(object[property]);
    }
};

/**
 * Formats a Twitter URL with handle
 *
 * @param {string} handle
 * @returns {string}
 */
var twitterUrl = function(handle) {
    if (handle) {
        return "https://twitter.com/" + handle;
    }
};

/**
 * Formats a Facebook URL with handle
 *
 * @param {string} handle
 * @returns {string}
 */
var facebookUrl = function(handle) {
    if (handle) {
        return "https://facebook.com/" + handle;
    }
};

/**
 * Formats a LinkedIn URL with handle
 *
 * @param {string} handle
 * @returns {string}
 */
var linkedinUrl = function(handle) {
    if (handle) {
        return "https://linkedin.com/in/" + handle;
    }
};

/**
 * Formats a Google Plus URL with handle
 *
 * @param {string} handle
 * @returns {string}
 */
var googlePlusUrl = function(handle) {
    if (handle) {
        return "https://plus.google.com/+" + handle;
    }
};

/**
 * Checks for property in obj and adds a formatted version to obj
 *
 * @param {object} obj
 * @param {string} property
 */
var breakParagraphs = function(object, property) {
    if(object[property]) {
        object[property + "_paragraphs"] = object[property].split(/\n/gm);
    }
};

/**
 * There are many checks for arr[0] === "true" because of the way we use lists in profile data
 * to allow users to select a boolean value using a tag when they fill out their profiles.
 *
 * Checks if arr[0] is true.
 * @param {array} value
 * @returns {boolean}
 */
var selectBoxIsTrue = function(value) {
    return !!(value && value.length && value[0].toLowerCase() === "true");
};

/**
 * Generates a Google Maps API endpoint
 *
 * @param {string} key Google Maps API Key
 * @param {string} callback
 */
var loadGoogleMapsScript = function(key, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    var keyString = key ? "key=" + key : "";
    var callbackString = callback ? "callback=" + callback : "";
    if(keyString && callbackString) {
        script.src = "https://maps.googleapis.com/maps/api/js?" + keyString + "&" + callbackString;
    } else if (keyString && !callbackString) {
        script.src = "https://maps.googleapis.com/maps/api/js?" + keyString;
    } else if (!keyString && callbackString) {
        script.src = "https://maps.googleapis.com/maps/api/js?" + callbackString;
    } else {
        script.src = "https://maps.googleapis.com/maps/api/js";
    }
    document.body.appendChild(script);
};

var renderTemplate = function(selector, html, data) {
    var element = document.querySelector(selector);
    if(element.length) {
        var template = _.template(html);
        element.appendChild(template(data));
    }
};

exports.stripNonDigits = stripNonDigits;
exports.makeAbsolute = makeAbsolute;
exports.parseUrl = parseUrl;
exports.getPageName = getPageName;
exports.addFormattedPhone = addFormattedPhone;
exports.twitterUrl = twitterUrl;
exports.facebookUrl = facebookUrl;
exports.linkedinUrl = linkedinUrl;
exports.googlePlusUrl = googlePlusUrl;
exports.breakParagraphs = breakParagraphs;
exports.selectBoxIsTrue = selectBoxIsTrue;
exports.loadGoogleMapsScript = loadGoogleMapsScript;
exports.renderTemplate = renderTemplate;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/utils.js
// module id = 189
// module chunks = 8